import _ from 'lodash';
import DepsService from 'services/dependencies';

import { setUserPrivileges } from 'auth/actions/session.actions';
import helpers from './helpers';

const PRIVILGES_CONTEXT = 'privilegeTemplates';

function initializeModel(deps, model) {
  return _.merge(model, {
    privileges: {},
    privilegesArray: [],
    hiddenPrivileges: {},
    hiddenPrivilegesArray: [],
    privilegeTemplates: {
      lotteryView: {
        presets: [],
        currentPreset: null,
        currentPresetOriginalPrivileges: null,
        isCurrentPresetDirty: false,
        displayTypes: [],
        languageValidation: {},
      },
      retailerView: {
        presets: [],
        currentPreset: null,
        currentPresetOriginalPrivileges: null,
        isCurrentPresetDirty: false,
        displayTypes: [],
        languageValidation: {},
      },
      roles: {
        selectedRole: {},
        currentRole: {},
        PrivilegeTemplatesList: [],
        isCurrentRoleDirty: false,
      },
      rolesDialog: {
        languageValidation: {},
      },
      retailerViewDialog: {
        languageValidation: {},
      },
      lotteryViewDialog: {
        languageValidation: {},
      },
    },
  });
}

function loadPrivileges(deps, model, userClass, retailerType) {
  const queryParams = retailerType ? { retailerType } : null;
  return deps.restSrv
    .list(PRIVILGES_CONTEXT, model.session.rest.privileges.dynamic.url, queryParams, { userClass })
    .then((privileges) =>
      _.flow([
        (obj) => _.set(obj, 'privilegesArray', privileges),
        (obj) => _.set(obj, 'privileges', helpers.createTree(privileges, 'displayPath')),
      ])(model)
    );
}

function loadUserSessionPrivileges(deps, model) {
  return deps.restSrv.list(PRIVILGES_CONTEXT, model.session.rest.privileges.session.user.calculate.url, null, null).then((privileges) => {
    const privs = _.merge(helpers.transformPrivileges(privileges), deps.config.defaultLoggedInPrivileges);
    DepsService.$ngRedux.dispatch(setUserPrivileges(privs));
    return _.set(model, 'session.privileges', privs);
  });
}

function loadPreset(deps, model, presetId, role) {
  return deps.restSrv.list(PRIVILGES_CONTEXT, model.session.rest.privileges[role].template.get.url, null, {
    templateId: presetId,
  });
}

// Edit Account functions
function resetCurrentPreset(deps, model, role) {
  const templateId = model.user.editAccount.currentUserPreset.id;
  return deps.restSrv
    .list(PRIVILGES_CONTEXT, model.session.rest.privileges[role].template.get.url, null, {
      templateId,
    })
    .then((response) => {
      model.user.editAccount.currentUserPreset = { ...model.user.editAccount.currentUserPreset, privileges: response.privileges };
      return model;
    });
}

export default {
  initializeModel,
  loadPrivileges,
  loadUserSessionPrivileges,
  resetCurrentPreset,
  loadPreset,
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/logic/privilege-templates.js